import {z} from 'zod';
import {
	makeOptionalPropsNullable,
	SchemaValidationErrorLabel,
} from '@netx/core-schema';

export enum GroupType {
	ADMIN = 'ADMIN',
	EVERYONE = 'ALL_USERS',
	USER_CREATED = 'USER_CREATED',
}

export const GroupSchema = z.object({
	id: z.number().int().gt(0, 'Invalid `id`'),
	name: z.string().nonempty(SchemaValidationErrorLabel.REQUIRED),
	userCount: z.number().int().gt(-1, 'Invalid `userCount`'),
	hasAccessFilters: z.boolean(),
	type: z.nativeEnum(GroupType),
});

export default GroupSchema;

/** validate against a new group */
export const GroupSchemaNew = makeOptionalPropsNullable(
	GroupSchema.omit({
		userCount: true,
	}).partial({
		id: true,
	}),
);

/** all group fields */
export const GroupField = GroupSchema.keyof().enum;

/** a true group record */
export type ISystemGroup = z.infer<typeof GroupSchema>;

/** a new group record */
export type ISystemGroupNew = z.infer<typeof GroupSchemaNew>;

/** group form values schema */
export const GroupFormSchema = GroupSchema.pick({
	name: true,
});
export type ISystemGroupFormValues = z.infer<typeof GroupFormSchema>;
